import { Contract } from "@/pages/human-resources/time-management/business/contract/Contract.ts";
import { contractTypeFromString } from "@/pages/human-resources/time-management/business/contract/ContractType.ts";
import { parseIsoDateTime } from "@/shared/utils/Dates.ts";

export interface ContractOut {
  id: number;
  siteId: number;
  contractType: string;
  originalStartDate: string;
  startDate: string;
  endDate: string | undefined;
  roleId: number;
  sectionId: number;
  weeklyWorkingHours: number | undefined;
  monthlyWorkingHours: number | undefined;
}

export function mapToContract(dto: ContractOut): Contract {
  return new Contract(
    dto.id.toString(),
    dto.siteId.toString(),
    contractTypeFromString(dto.contractType),
    parseIsoDateTime(dto.originalStartDate),
    parseIsoDateTime(dto.startDate),
    dto.endDate === undefined ? undefined : parseIsoDateTime(dto.endDate),
    dto.roleId.toString(),
    dto.sectionId.toString(),
    dto.weeklyWorkingHours,
    dto.monthlyWorkingHours,
  );
}
